import * as auth from "../app/modules/Auth/_redux/authRedux";
import store from "./store";
const { dispatch } = store;

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { token  },
      } = store.getState();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const originalRequest = error.config;
      const {  logout } = auth.actions;
      const {
        auth: { token },
      } = store.getState();
      if (error.response) {
        if (token && error.response.status === 401) {
          originalRequest._retry = true;

          dispatch(logout());
        }
      }
      return Promise.reject(error);
    }
  );
}
